import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BundlePackageInformationService {

  private activeBundle: BehaviorSubject<String> = new BehaviorSubject<String>("");
  activeCheckBundle = this.activeBundle.asObservable();

  constructor(private readonly http: HttpClient) { }
  

  createSalesBundle(data: any) {
    let headers = new HttpHeaders();
    headers = headers.set('user-name', 'test-user').set('Content-Type', 'application/json');
    return this.http.post<any>('mhvoucher/salescombo/bundles', data, {headers: headers})
  }

  updateSalesBundle(bundleId:any, data:any) {
    let headers = new HttpHeaders();
    headers = headers.set('user-name', 'test-user').set('Content-Type', 'application/json');
    return this.http.patch<any>(`mhvoucher/salescombo/bundles/${bundleId}`, data, {headers: headers})
  }

  sendImageData(bundleId:any, data:any) {
    let headers = new HttpHeaders();
    headers = headers.set('user-name', 'test-user').set('partner','1');
    return this.http.patch<any>(`mhvoucher/salescombo/bundles/${bundleId}/images`, data, {headers: headers})
  }

  searchVariantSalesBundle(filter:any) {
    let headers = new HttpHeaders();
    let params = new HttpParams()
    headers = headers.set('partner','1');
     params = params.set('limit', 10)
    if (filter) {
      params = params.set('search', filter)
    }
    return this.http.get<any>(`mhvoucher/vouchers?active=true&isCatalogue=true&${params}&bundle=true`, {headers: headers})
  }

  searchVariantSalesBundle1(filter:any,count:number) {
    let headers = new HttpHeaders();
    let params = new HttpParams()
    headers = headers.set('partner','1');
     params = params.set('limit', count+1)
    if (filter) {
      params = params.set('search', filter)
    }
    return this.http.get<any>(`mhvoucher/vouchers?active=true&isCatalogue=true&${params}&bundle=true`, {headers: headers})
  }


  activeBundleDetail(value:string) {
    this.activeBundle.next(value)
  }

  public getVoucherList(filter?:string) {
    let headers = new HttpHeaders();
    let params = new HttpParams()
    headers = headers.set('Partner', '1');
    params = params.set('limit', 20)
    if (filter) {
      params = params.set('search', filter)
    }
    return this.http.get<any>(`mhvoucher/vouchers?&${params}`, {
      headers: headers,
     
    });
  }
  
}
